import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { useAuth } from './hooks/useAuth';
import { SocketProvider } from './context/SocketContext';
import { useTheme } from './context/ThemeContext';
import { Layout } from './components/layout/Layout';
import { Login } from './pages/Login';
import { AcceptInvite } from './pages/AcceptInvite';
import { Dashboard } from './pages/Dashboard';
import { ProjectList } from './pages/projects/ProjectList';
import { ProjectDetail } from './pages/projects/ProjectDetail';
import { CutDetail } from './pages/cuts/CutDetail';
import { FileExplorer } from './pages/files/FileExplorer';
import { Users } from './pages/admin/Users';
import { SharedFile } from './pages/shared/SharedFile';
import { ActivityFeedPage } from './pages/activity/ActivityFeedPage';
import { ChangelogPage } from './pages/changelog/ChangelogPage';

function ThemeSync() {
  const { user } = useAuth();
  const { setTheme } = useTheme();

  useEffect(() => {
    if (!user?.themePreference) return;
    setTheme(user.themePreference as 'default' | 'amber' | 'indigo' | 'purple');
  }, [user?.themePreference]);

  return null;
}

export default function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <ThemeSync />
      <SocketProvider>
        <Toaster 
          position="top-right" 
          richColors 
          closeButton
          toastOptions={{
            duration: 5000,
          }}
        />
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/shared/:shareToken" element={<SharedFile />} />
            
            {/* Protected routes */}
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/activity" element={<ActivityFeedPage />} />
              <Route path="/projects" element={<ProjectList />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/cuts/:id" element={<CutDetail />} />
              <Route path="/files" element={<FileExplorer />} />
              <Route path="/admin/users" element={<Users />} />
              <Route path="/changelog" element={<ChangelogPage />} />
              {/* Redirect old vibe routes to projects */}
              <Route path="/vibes/:id" element={<Navigate to="/projects" replace />} />
            </Route>
            
            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SocketProvider>
    </AuthProvider>
    </ErrorBoundary>
  );
}
